import React from 'react'

const OpenAccessArchiving = () => {
  return (
    <div>
      <p>
        The <b>International Journal of Innovative Studies in Social Sciences (IJISSS)</b> 
        follows a <b>gold open-access policy</b>, ensuring that all published articles are 
        <b>freely available</b> to readers worldwide without paywalls or subscription barriers.
      </p>

      <br />
      <h4 className="fw-bold text-blue font-size-21">Open Access Policy</h4>
      <ul>
        <li>
          All articles are published under the 
          <b> Creative Commons Attribution License (CC BY 4.0)</b>.
        </li>
        <li>
          Authors retain full copyright while allowing others to use, 
          share, distribute, and reproduce the work with proper attribution.
        </li>
        <li>
          The journal does <b>not charge article processing fees (APCs)</b>, 
          ensuring equitable access to publication for scholars worldwide.
        </li>
      </ul>

      <br />
      <h4 className="fw-bold text-blue font-size-21">Archiving and Digital Preservation</h4>
      <p>
        IJISSS follows robust preservation and archiving strategies to ensure 
        permanent accessibility of published research:
      </p>
      <ul>
        <li>
          <b>Institutional Repositories:</b> Articles are archived in university, 
          research, and social science institution repositories.
        </li>
        <li>
          <b>Digital Archiving:</b> The journal partners with digital libraries, 
          open-access repositories, and long-term preservation networks.
        </li>
        <li>
          <b>DOI Assignment:</b> Each article is assigned a unique Digital Object 
          Identifier (DOI) to ensure stable and permanent online access.
        </li>
      </ul>

      <p>
        IJISSS is committed to promoting global access, transparency, and 
        long-term preservation of scholarly work in the field of social sciences.
      </p>
    </div>
  )
}

export default OpenAccessArchiving
